export default __webpack_public_path__ + "static/media/opera.cae8018f.svg";